import { toast, type Id } from 'react-toastify';
import { SecretsUpdateToast } from '~/components/chat/SecretsUpdateToast';
import type { FileMap } from '~/lib/stores/files';
import { secretsStore } from '~/lib/stores/secrets';

let globalLastSecretsToastId: Id | undefined;
let lastCheckedFiles: FileMap | undefined;

export const recheckMissingSecrets = async () => {
  if (!globalLastSecretsToastId || !lastCheckedFiles) {
    return;
  }

  await checkMissingSecrets(lastCheckedFiles);
};

export const checkMissingSecrets = async (files: FileMap) => {
  const filesToCheck = files;

  lastCheckedFiles = files;

  let secrets = secretsStore.secrets.get();

  if (secrets.length === 0) {
    secrets = (await secretsStore.fetchSecrets()) ?? [];
  }

  const currentSecrets = Array.from(new Set(secrets.map((secret) => secret.name)));

  const denoEnvPattern = /Deno\.env\.get\(['"]([^'"]+)['"]\)/g;

  const findDenoEnvVariables = (text: string) => {
    return [...text.matchAll(denoEnvPattern)].map((match) => ({
      variable: match[1],
      fullMatch: match[0],
      position: match.index,
    }));
  };

  const secretsUsed = new Set<string>();

  for (const filePath in filesToCheck) {
    const file = filesToCheck[filePath];

    if (file?.type === 'file') {
      const envVars = findDenoEnvVariables(file.content);

      envVars.forEach((envVar) => secretsUsed.add(envVar.variable));
    }
  }

  const missingSecrets = Array.from(secretsUsed).filter((secretName) => !currentSecrets.includes(secretName));

  if (!missingSecrets.length) {
    if (globalLastSecretsToastId) {
      toast.dismiss(globalLastSecretsToastId);
      globalLastSecretsToastId = undefined;
      lastCheckedFiles = undefined;
    }

    return;
  }

  if (globalLastSecretsToastId) {
    toast.update(globalLastSecretsToastId, {
      render: () => <SecretsUpdateToast missingSecrets={missingSecrets} />,
      toastId: globalLastSecretsToastId,
    });

    return;
  }

  globalLastSecretsToastId = toast.info(<SecretsUpdateToast missingSecrets={missingSecrets} />, {
    autoClose: false,
    toastId: globalLastSecretsToastId,
  });
};
